import React, {  useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import moment from "moment";
import { AnnouncementsIcon, DatePickerIconUserEvents,  NewBackArrowIconEventPage, NewNextArrowIconEventPage, RewardPointsIcon } from '../../utils/icons'; // adjust imports
import { Container, Layout, SliderContainer, CompanyCard, ReservedButton ,OuterCardContainer} from  './styles'; // your styled components
import PropTypes from "prop-types";
import LazyImage from "../common/LazyImage/LazyImage";
import parse from "react-html-parser";
import { useHistory } from 'react-router-dom';
import { ImageUrl } from "../../utils/constants";
// import { showSuccessToast } from "./ToastHelper";
import SkeletonLoder from "../common/skeletonLoder";
import { convertDateInTimezone, convertMonthFromDate } from "../../utils/methods";

const WellnessSlider = ({
  title = "Announcements",
  data = [],
  cardRender, 
  showArrows = true,
  showDots = true,
  myAnnouncementCard = false,
  myActicityCard = false,
  myFocusCard = false,
  loading = true, 
  CategoryType="",
  CatgoryName="",
  icon = <AnnouncementsIcon/>
}) => {


  window.console.log("name",CatgoryName)
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(1);
  const history = useHistory();
  const [timeout, setTimeoutState] = useState(false);


  const handleBeforeChange = (_, newIndex) => {
    setCurrentSlide(newIndex + 1);
  };

  const redirectionToDetailsPage = (data) => {

    if(data?.card_type === "fitness_video" ) 
    {
      history.push(`/education/videos-library/${data?.id}`)
    }
    else if(data?.card_type === "recipe" ) 
    {
      history.push(`/wellness-resources/recipe-details/${data?.id}`)
    }
    else if(data?.card_type === "article") 
    {
      history.push(`/wellness-resources/article-details/${data?.id}`)
    }
  }

  


  useEffect(() => {
    if (timeout) {
      const timer = window.setTimeout(() => {
        setTimeoutState(false);
      }, 5000);
  
      return () => window.clearTimeout(timer); // cleanup
    }
  }, [timeout]);




  const sliderSettings = {
    dots: showDots,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    draggable: true,
    adaptiveHeight: false,
    variableWidth: false,
    beforeChange: handleBeforeChange,
    responsive: [
      {
        breakpoint: 1252,
        settings: { dots: showDots, infinite: false, slidesToShow: 1, arrows: true },
      },
      {
        breakpoint: 600,
        settings: { dots: showDots, infinite: false, slidesToShow: 1, arrows: true },
      },
    ],
  };



  if (loading)
  { return (
    <SkeletonLoder
      width={"1248px"}
      height={"450px"}
    />
  )}

  return (


    <OuterCardContainer isOuterpadding={data.length > 1 ? "0px 20px 46px 20px" : "0px 20px 20px 20px"}>
      <Layout margin="20px 0 0 0" padding="0px">
        <div className="headingMain">
          <div style={{ gap: "12px" }} className="heading">
            {/* <AnnouncementsIcon /> */}
            {icon}
            {title}
          </div>

          { showArrows && data.length > 1 && (
            <div className="arrows">
              {currentSlide > 1 ? (
                <div className="iconBackground" onClick={() => sliderRef.current?.slickPrev()}>
                  {NewBackArrowIconEventPage("#DA6C74")}
                </div>
              ):null}
              <div className="text">
                {currentSlide}/{data.length}
              </div>
              {currentSlide < data.length ? (
                <div className="iconBackground" onClick={() => sliderRef.current?.slickNext()}>
                  {NewNextArrowIconEventPage("#DA6C74")}
                </div>
              ):<div className="iconPlaceholder"></div>}
            </div>
          )}
        </div>

        <Container style={{border: "none",borderRadius:"8px",marginTop:"16px",height:"344px"}}>
          <SliderContainer display="flex" content="center" marginValue="0">
            <Slider {...sliderSettings} ref={sliderRef}>
              {data.map((item, index) =>
                cardRender ? (
                  cardRender(item, index) // use custom render if passed
                ) : (
                  <div className="card" key={index}>
                    <CompanyCard detailsCardPadding="20px" 
                      isCursorPointer={"default"}
                      onClick={() => redirectionToDetailsPage(item) }>
                      <LazyImage className="imageCardUserDashboard" src={`${ImageUrl}/${item?.image || item?.recipe_image || item?.thumbnail_image}`} alt="event" />
                     
                      <div className="detailsCard">
                        <div className="title">{item?.type === "recipe" || CategoryType === "recipe" ? item?.recipe_name || item?.name || item?.title : item?.title || item?.video_title}</div>
                        {myFocusCard ? <div className="details">{parse(item?.description)}</div>:
                          <div className="details">{parse(item?.body)}</div>}

                        {myActicityCard || myAnnouncementCard ? <div className="date">
                          <div className="iconV1">
                            <DatePickerIconUserEvents />
                          </div>
                          <div className="detail">
                            <div className="challengeDetails">
                              {
                                moment(convertDateInTimezone(item?.start_date)._d).format("YYYY") === 
                                moment(convertDateInTimezone(item?.end_date)._d).format("YYYY")
                                  ? `${convertMonthFromDate(
                                    moment(convertDateInTimezone(item?.start_date)._d).format("MMMM D")
                                    
                                  )} - ${convertMonthFromDate(
                                    moment(convertDateInTimezone(item?.end_date)._d).format("MMMM D, YYYY")
                                  )}`
                                  : `${convertMonthFromDate(
                                    moment(convertDateInTimezone(item?.start_date)._d).format("MMMM D, YYYY")
                                  )} - ${convertMonthFromDate(
                                    moment(convertDateInTimezone(item?.end_date)._d).format("MMMM D, YYYY")
                                  )}`
                              }
                            </div>
                          </div>
                        </div> : null}

                        {
                          (item?.points && item?.points !== "0" ? <div className="date">
                            <div className="iconV1">
                              <RewardPointsIcon />
                            </div>
                            <div className="detail">
                             +{item?.points} {item?.points > 1 ? "experience points" : "experience point"}
                            </div>
                          </div> : null)
                        }
                        {
                          myFocusCard ?
                            (<div className="buttonContainer">
                              {item?.type === "fitness_video" || CategoryType=== "fitness_video"  ?
                                (
                                  <ReservedButton active={1}  onClick={()=>history.push(`/education/videos-library/${item?.id}`)}>
                                    Get Moving
                                  </ReservedButton>
                                ) : item?.type === "recipe" || CategoryType === "recipe"  ?
                                  ( <ReservedButton 
                                    active={1} 
                                    onClick={()=>history.push(`/wellness-resources/recipe-details/${item?.id}`)}>
                                 Start Cooking 
                                  </ReservedButton>)
                                  :   item?.type=== "article"   || CategoryType === "article"  ?
                                    (  <ReservedButton  
                                      active={1} 
                                      onClick={()=>history.push(`/wellness-resources/article-details/${item?.id}`)}>
                                      Read Article 
                                    </ReservedButton>)
                                    : null
                              }
                            </div>) : null
                        }
                      </div>
                    </CompanyCard>
                  
                  </div>
                )
              )}
            </Slider>
          </SliderContainer>
        </Container>
      </Layout>
    </OuterCardContainer>
  );
};

WellnessSlider.propTypes =
{
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  cardRender: PropTypes.func,
  showArrows: PropTypes.bool,
  showDots: PropTypes.bool,
  myAnnouncementCard: PropTypes.bool,
  myActicityCard: PropTypes.bool,
  myFocusCard: PropTypes.bool,
  refreshAnnouncements: PropTypes.func,
  activeFocusKey: PropTypes.string,
  loading: PropTypes.bool,
  icon: PropTypes.node,  
  CatgoryName:PropTypes.string,
  CategoryType:PropTypes.string,
}


export default WellnessSlider;





